import React, {useState} from "react";
import Form, {FormFooter, FormHeader} from "../common/Form/Form";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useInputHandler, useUpdateHandler} from "../../utilities/formHooks";
import {ValueList} from "../common/InputList/InputList";
import {createCloseHandler} from "../../utilities/componentFunctions";
import PopupModel from "../../models/scheduler/PopupModel";
import NetworkConfigurationModel from "../../models/settings/NetworkConfigurationModel";
import HTMLTextInput from "../common/HTMLTextInput/HTMLTextInput";


function UpdateNetworkConfigurationForm() {
    const {t} = useTranslation(['aria', 'networkConfiguration', 'common']);
    const dispatch = useDispatch();

    const networkConfiguration = useSelector(state => state.networkConfiguration);
    const {isDisabled} = useSelector(state => state.componentStates.networkConfigurationForm);

    const [state, setState] = useState({
        proxyHost: networkConfiguration.proxyHost || '',
        proxyPort: networkConfiguration.proxyPort || ''
    });

    const [nonProxyHosts, setNonProxyHosts] = useState(networkConfiguration.nonProxyHosts || []);
    const [whitelistedCertFingerprints, setWhitelistedCertFingerprints] = useState(networkConfiguration.whitelistedCertFingerprints || []);

    const updateHandler = useUpdateHandler({
        updateState: setState
    });
    const inputHandler = useInputHandler({
        updateHandler
    });

    function onSubmit() {
        dispatch(NetworkConfigurationModel.actionCreators.submitForm({
            ...state,
            nonProxyHosts,
            whitelistedCertFingerprints
        }));
    }

    const onClose = createCloseHandler({
        popupKey: 'proxyServerUpdateDiscard',
        values: {...state, nonProxyHosts},
        showWarning: payload => dispatch(PopupModel.actionCreators.showWarning(payload)),
        close: () => dispatch(NetworkConfigurationModel.componentActionCreators.updateDisplay({isFormActive: false}))
    });


    const isAddEnabled = NetworkConfigurationModel.validateFormData({...state, nonProxyHosts});

    return (
        <Form onClose={onClose} isDisabled={isDisabled}
            closeButtonAriaLabel={t('networkConfiguration:option.closeForm')}
            header={
                <FormHeader text={t('networkConfiguration:label.proxyServer')} iconName={'proxyServer'}
                    isDisabled={isDisabled}/>
            }
            body={
            <>
                <div className="flex space-between display-input">
                    <div style={{width: 'calc(100% - 7.5rem'}}>
                        <HTMLTextInput label={t('networkConfiguration:label.proxyHost')} name={'proxyHost'}
                            value={state.proxyHost} onChange={inputHandler} isDisabled={isDisabled} isRequired/>
                    </div>

                    <div style={{width: '5rem'}}>
                        <HTMLTextInput label={t('networkConfiguration:label.proxyPort')} name={'proxyPort'} type={'number'}
                            value={state.proxyPort} onChange={inputHandler} isDisabled={isDisabled} isRequired/>
                    </div>
                </div>

                <div className="display-input">
                    <ValueList id={'proxyServerNonProxyHosts'} label={t('networkConfiguration:label.nonProxyHosts')}
                        ariaLabelKey={'NonProxyHost'} values={nonProxyHosts} setValues={setNonProxyHosts} isDisabled={isDisabled}/>
                </div>

                <div className="display-input">
                    <ValueList id={'proxyServerWhitelistedCertFingerprints'} label={t('networkConfiguration:label.whitelistedCertFingerprints')}
                        ariaLabelKey={'WhitelistedCertFingerprint'} values={whitelistedCertFingerprints}
                        setValues={setWhitelistedCertFingerprints} isDisabled={isDisabled}/>
                </div>
            </>
            }
            footer={
                <FormFooter addText={t('networkConfiguration:option.update')} onAddClick={onSubmit}
                    onCancel={onClose} isAddEnabled={isAddEnabled} isDisabled={isDisabled}
                />
            }
        />
    )
}

export default UpdateNetworkConfigurationForm;
